import { defineComponent as _defineComponent } from 'vue'
import { onUnmounted, ref } from 'vue'
import { api } from "@/main";
import { AIMemory, AIMemoryType, AIPrincipal, AIPersonalityPreset, Subscription } from "@/api";
import Card from "@/components/Card.vue";
import Permissions from "@/components/Permissions.vue";
import AIPrincipalTokens from "@/components/AIPrincipalTokens.vue";
import AIFormattedText from "@/components/AIFormattedText.vue";
import EditableObject from "@/components/EditableObject.vue";
import DynamicForm from "@/components/DynamicForm.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'AIDashboard',
  props: ['aiId'],
  emits: ['breadcrumbs', 'menuItems'],
  setup(__props, { emit }) {

const props = __props




let memorySubscription: Subscription | null = null;

const ai = ref<AIPrincipal | null>(null);
const presets = ref<AIPersonalityPreset[]>([]);
const memories = ref<AIMemory[]>([]);
const messages = ref<AIMemory[]>([]);
const showCreateMemoryDialog = ref(false);
const memoryPanel = ref<number[]>([]);
const editingMemoryId = ref<string | null>(null);
const editingMemoryText = ref('');
const required = (value: string) => !!value || 'Required';

function toolLabel(message: AIMemory): string {
  if (message.memoryText.startsWith('Functions Called:'))
    return 'Functions Called'
  if (message.memoryText.startsWith('Function Attempts:'))
    return 'Function Attempts'
  return message.memoryText.startsWith('[MCP] ') ? 'MCP Tool' : 'Tool'
}

function toolText(message: AIMemory): string {
  if (message.memoryText.startsWith('Functions Called:'))
    return message.memoryText.substring('Functions Called:'.length).trim()
  if (message.memoryText.startsWith('Function Attempts:'))
    return message.memoryText.substring('Function Attempts:'.length).trim()
  return message.memoryText.startsWith('[MCP] ') ? message.memoryText.substring(6) : message.memoryText
}

function saveAI(aiPrincipal: AIPrincipal): Promise<AIPrincipal> {
  return api.ai.saveAI(aiPrincipal).then((savedAI) => {
    ai.value = savedAI;
    return savedAI;
  });
}

function saveAIWithPreset(formData: AIPrincipal & { presetType?: string | null }): Promise<AIPrincipal> {
  return saveAI(new AIPrincipal(
    formData.id,
    formData.version,
    formData.name,
    formData.personality,
    formData.recurringBehavior,
    formData.aiModel,
    formData.createdTimestamp,
    formData.deletedTimestamp
  ));
}

function applyPreset(mutableObject: AIPrincipal & { presetType?: string | null }) {
  const preset = presets.value.find((candidate) => candidate.type === mutableObject.presetType);
  if (!preset)
    return;
  mutableObject.personality = preset.personality;
  mutableObject.recurringBehavior = preset.recurringBehavior;
}

function editableAI(aiPrincipal: AIPrincipal) {
  return {
    ...aiPrincipal,
    presetType: null
  };
}

function beginEditMemory(memory: AIMemory, index: number) {
  editingMemoryId.value = memory.id;
  editingMemoryText.value = memory.memoryText;
  memoryPanel.value = [index];
}

function cancelEditMemory() {
  editingMemoryId.value = null;
  editingMemoryText.value = '';
  memoryPanel.value = [];
}

function beginCreateMemory() {
  showCreateMemoryDialog.value = true;
  cancelEditMemory();
}

function createMemory(form: { memoryText: string }) {
  if (!ai.value)
    return Promise.resolve();

  return api.ai.createAIMemory(ai.value.id, form.memoryText.trim());
}

function saveMemory(memory: AIMemory) {
  const trimmedMemoryText = editingMemoryText.value.trim();
  if (!trimmedMemoryText)
    return Promise.resolve();

  return api.ai.updateAIMemory(memory, trimmedMemoryText).then(() => {
    cancelEditMemory();
  });
}

api.ai.getAI(props.aiId).then(
  newAI => {
    ai.value = newAI;

    emit('menuItems', []);
    emit('breadcrumbs', [{
      text: ai.value.name,
      icon: '$smartHome',
      to: '/ai/' + props.aiId
    }]);

    if (memorySubscription != null)
      api.unsubscribe(memorySubscription);
    memorySubscription = api.ai.getAIMemories(props.aiId, (memory) => {
      if (memory.type === AIMemoryType.MEMORY) {
        let foundIndex = -1;
        memories.value.forEach((message, index) => {
          if (message.id === memory.id) {
            foundIndex = index;
            message.version = memory.version;
            message.memoryText = memory.memoryText;
            message.createdTimestamp = memory.createdTimestamp;
            message.deletedTimestamp = memory.deletedTimestamp;
          }
        });

        if (foundIndex >= 0) {
          if (memory.deletedTimestamp)
            memories.value.splice(foundIndex, 1);
        } else {
          memories.value.unshift(memory);
        }
      } else {
        let found = false;
        messages.value.forEach(message => {
          if (message.id === memory.id) {
            found = true;
            message.deletedTimestamp = memory.deletedTimestamp;
          }
        })

        if (!found) {
          if (messages.value.length === 0 || Number(memory.id) < Number(messages.value[0].id)) {
            messages.value.unshift(memory);
          } else {
            messages.value.push(memory);
          }
        }

        while (messages.value.length > 20)
          messages.value.shift();
      }
    });
  }
)

api.ai.getAIPersonalityPresets().then((fetchedPresets) => {
  presets.value = fetchedPresets;
})

onUnmounted(() => {
  if (memorySubscription != null)
    api.unsubscribe(memorySubscription);
})


return { __sfc: true,props, emit, memorySubscription, ai, presets, memories, messages, showCreateMemoryDialog, memoryPanel, editingMemoryId, editingMemoryText, required, toolLabel, toolText, saveAI, saveAIWithPreset, applyPreset, editableAI, beginEditMemory, cancelEditMemory, beginCreateMemory, createMemory, saveMemory, api, AIMemoryType, Card, Permissions, AIPrincipalTokens, AIFormattedText, EditableObject, DynamicForm }
}

})